export const defaultLoader = [
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    },
    {
        height: '20px'
    }
]